const assetsPath = 'https://gcc-component-assets.s3.amazonaws.com/countertops-components';
export default assetsPath;
